import React, { useState } from "react";
import { api } from "../lib/api";
import { Input } from "./ui/input";
import { Button } from "./ui/button";
import { BingoCard, completeRows } from "./BingoBits";
import { Search, X } from "lucide-react";

export function TicketLookup({ gameId, pin, drawn }) {
  const [q, setQ] = useState("");
  const [results, setResults] = useState(null);
  const [selected, setSelected] = useState(null);
  const [busy, setBusy] = useState(false);

  const search = async () => {
    if (!q.trim()) return;
    setBusy(true);
    try {
      const r = await api.get(`/games/${gameId}/tickets/search`, { params: { q } });
      setResults(r.data);
      setSelected(r.data.length === 1 ? r.data[0] : null);
    } catch (e) {
      setResults([]);
    } finally {
      setBusy(false);
    }
  };

  const marked = (card) => card.flat().filter((n) => n !== null && drawn.includes(n)).length;

  return (
    <div className="p-5 rounded-2xl bg-[#12141D] border border-white/10" data-testid="ticket-lookup">
      <div className="text-xs uppercase tracking-widest text-slate-400 mb-3">Kaart opzoeken (voor bellers)</div>
      <div className="flex gap-2">
        <Input data-testid="lookup-input" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Naam van speler of kaart-ID"
               onKeyDown={(e) => e.key === "Enter" && search()} className="bg-[#0B0C10] border-white/10 text-white" />
        <Button data-testid="lookup-submit" onClick={search} disabled={busy} className="bg-[#00F0FF] text-[#0B0C10] hover:bg-[#00d4e0] font-bold">
          <Search className="w-4 h-4" />
        </Button>
      </div>

      {results && results.length === 0 && <div className="text-sm text-slate-500 mt-3" data-testid="lookup-empty">Geen kaarten gevonden.</div>}

      {results && results.length > 1 && !selected && (
        <div className="mt-3 space-y-1 max-h-48 overflow-y-auto" data-testid="lookup-results">
          {results.map((t) => (
            <button key={t.id} data-testid={`lookup-result-${t.id}`} onClick={() => setSelected(t)}
                    className="w-full text-left p-2 rounded-lg bg-[#0B0C10] border border-white/10 hover:border-[#00F0FF]/50 flex justify-between text-sm">
              <span className="font-bold">{t.display_name}</span>
              <span className="text-slate-500 font-mono text-xs">{t.id.slice(0, 8)} · {marked(t.card)}/15 · {completeRows(t.card, drawn).length} rij(en)</span>
            </button>
          ))}
        </div>
      )}

      {selected && (
        <div className="mt-3" data-testid="lookup-selected">
          <div className="flex items-center justify-between mb-2">
            <div>
              <div className="font-bold" data-testid="lookup-name">{selected.display_name}</div>
              <div className="text-xs text-slate-500 font-mono">{selected.id.slice(0, 8)}… · {marked(selected.card)}/15 gemarkeerd · {completeRows(selected.card, drawn).length}/3 rijen vol</div>
            </div>
            <button data-testid="lookup-clear" onClick={() => { setSelected(null); if (results?.length <= 1) setResults(null); }} className="p-1.5 rounded-md hover:bg-white/10"><X className="w-4 h-4" /></button>
          </div>
          <BingoCard card={selected.card} drawn={drawn} winRows={completeRows(selected.card, drawn)} />
          <p className="text-xs text-slate-500 mt-2">Groen = volledige rij.</p>
        </div>
      )}
    </div>
  );
}
